import * as React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation, useMainStackRoute } from 'utils/types/navigationV6';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { selectGeoInfo } from '../reducers/selectors';
const GeographicAssetCategorizationView = () => {
    const navigation = useMainStackNavigation();
    const fundsGeoInfo = useAppSelector(selectGeoInfo);
    const route = useMainStackRoute();
    const onPress = React.useCallback((title) => () => {
        navigation.navigateDeprecated('InvestDiscoverCategorizationDetails', {
            type: 'geo',
            initialSelected: title,
            depositAndBuyFlowParams: route.params?.depositAndBuyFlowParams,
        });
    }, [route.params?.depositAndBuyFlowParams]);
    return (<>
      <Spacer h={8}/>
      <SectionHeader horizontalMargins>Regions</SectionHeader>
      <View style={styles.container}>
        {fundsGeoInfo.map((fundInfo) => (<View style={styles.cardWrapper} key={fundInfo.fundInfo.title}>
            <TouchableBounceCard onDark noMargin withPadding onPress={onPress(fundInfo.fundInfo.title)} style={styles.card}>
              <Image source={fundInfo.fundInfo.imgUrl} style={styles.image}/>
              <Spacer h={16}/>
              <Text Text-16>{fundInfo.fundInfo.title}</Text>
              <Text TextThin-14 Secondary>
                {fundInfo.fundInfo.subTitle}
              </Text>
            </TouchableBounceCard>
          </View>))}
      </View>
    </>);
};
export default React.memo(GeographicAssetCategorizationView);
const styles = StyleSheet.create({
    container: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        marginVertical: rem(12),
        marginHorizontal: rem(8),
    },
    cardWrapper: {
        padding: rem(8),
        flexGrow: 1,
        flexBasis: '40%',
    },
    card: {
        flex: 1,
    },
    image: {
        width: rem(44),
        height: rem(44),
    },
});
